import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { filter, take } from 'rxjs';
import { PartnerMonthlyInvoiceGenerateComponent } from './partner-monthly-invoice-generate.component';
import { PartnerInvoicesGridComponent } from './partner-invoices-grid.component';
import {
  ExternalDataService,
  PartnerDto,
} from '../../../services/externalDataService.service';
import { AuthService } from '../../../services/auth.service';
import { HasPermissionDirective } from '../../../directives/has-permission.directive';
import { CC_PERMISSIONS } from '../../../services/permission.service';

@Component({
  selector: 'app-partner-invoices',
  standalone: true,
  imports: [
    CommonModule,
    HasPermissionDirective,
    PartnerMonthlyInvoiceGenerateComponent,
    PartnerInvoicesGridComponent,
  ],
  templateUrl: './partner-invoices.component.html',
  styleUrl: './partner-invoices.component.css',
})
export class PartnerInvoicesComponent implements OnInit {
  readonly P = CC_PERMISSIONS;

  partners: PartnerDto[] = [];
  partnersLoading = false;
  partnersError = '';

  constructor(
    private externalData: ExternalDataService,
    private authService: AuthService,
  ) {}

  ngOnInit(): void {
    this.authService
      .getMsalInitializedObservable()
      .pipe(
        filter((initialized) => initialized),
        take(1),
      )
      .subscribe(() => {
        this.loadPartners();
      });
  }

  private loadPartners(): void {
    this.partnersLoading = true;
    this.partnersError = '';
    this.externalData.getAllPartners().subscribe({
      next: (list) => {
        this.partners = list ?? [];
        this.partnersLoading = false;
      },
      error: (err) => {
        console.warn('getAllPartners (invoices page)', err);
        this.partners = [];
        this.partnersError =
          'Partner list could not be loaded. You can still enter a partner ID below.';
        this.partnersLoading = false;
      },
    });
  }
}
